import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  Select,
  HStack,
  Divider,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { fetchHealthPlanMasterList } from '../Store/HealthPlanMasterReducer';
import { useMsal } from '@azure/msal-react';
import { IHealthPlanMaster } from '../Infrastructure/Interfaces';
import { fetchHealthPlanMappingList } from '../Store/HealthPlanMappingReducer';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const HealthPlanMasterModalPoupup: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const [isHealthPlanNameReq, setIsHealthPlanNameReq] = useState(false);
  const [isHealthPlanIdReq, setIsHealthPlanIdReq] = useState(false);
  const healthplanmasterlist: IHealthPlanMaster[] = useSelector(
    (state: any) => {
      return state.healthPlanMasterList.healthPlanMasterList;
    }
  );

  const [data, setdata] = useState({
    healthPlanMasterId: 0,
    healthPlanName: '',
    healthPlanId: '',
    sendOption1: '',
    sendOption2: '',
    sendOption3: '',
    sendOption4: '',
    isActive: true,
    createdBy: '',
    createdOn: '0001-01-01T00:00:00',
    modifiedBy: '',
    modifiedOn: '0001-01-01T00:00:00',
  });

  useEffect(() => {
    Store.subscribe(() => {
      setIsHealthPlanNameReq(false);
      setIsHealthPlanIdReq(false);
      setdata({
        ...data,
        healthPlanMasterId:
          Store.getState().setHealthPlanMasterItem.value.healthPlanMasterId,
        healthPlanName:
          Store.getState().setHealthPlanMasterItem.value.healthPlanName,
        healthPlanId:
          Store.getState().setHealthPlanMasterItem.value.healthPlanId,
        sendOption1: Store.getState().setHealthPlanMasterItem.value.sendOption1,
        sendOption2: Store.getState().setHealthPlanMasterItem.value.sendOption2,
        sendOption3: Store.getState().setHealthPlanMasterItem.value.sendOption3,
        sendOption4: Store.getState().setHealthPlanMasterItem.value.sendOption4,
        isActive: Store.getState().setHealthPlanMasterItem.value.isActive,
        createdBy: Store.getState().setHealthPlanMasterItem.value.createdBy,
        createdOn: Store.getState().setHealthPlanMasterItem.value.createdOn,
        modifiedBy: Store.getState().setHealthPlanMasterItem.value.modifiedBy,
        modifiedOn: Store.getState().setHealthPlanMasterItem.value.modifiedOn,
      });
    });
  }, []);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({
      ...data,
      [id]: value,
    });
  };

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();

    if (data.healthPlanName.trim() === '') {
      setIsHealthPlanNameReq(true);
      return;
    }
    if (data.healthPlanId.trim() === '') {
      setIsHealthPlanIdReq(true);
      return;
    }

    if (data.healthPlanMasterId > 0) {
      var item: any = healthplanmasterlist.find(
        x => x.healthPlanId == data.healthPlanId.trim()
      );

      if (item! != undefined) {
        if (item.healthPlanMasterId != data.healthPlanMasterId) {
          showToast(
            'Error!',
            data.healthPlanId +
              ' already exists. Please use a different id/number for a health plan.',
            'error'
          );
          return;
        }
      }
    }
    setSaveButtonLoading(true);

    const payload = {
      healthPlanMasterId: data.healthPlanMasterId,
      healthPlanName: data.healthPlanName.trim(),
      healthPlanId: data.healthPlanId.trim(),
      sendOption1: data.sendOption1 == undefined ? '' : data.sendOption1,
      sendOption2: data.sendOption2 == undefined ? '' : data.sendOption2,
      sendOption3: data.sendOption3 == undefined ? '' : data.sendOption3,
      sendOption4: data.sendOption4 == undefined ? '' : data.sendOption4,
      isActive: data.isActive,
      createdBy: data.createdBy,
      createdOn: '0001-01-01T00:00:00',
      modifiedBy: userid,
      modifiedOn: '0001-01-01T00:00:00',
    };

    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Payer/${
          data.healthPlanMasterId > 0
            ? 'update_healthplanname'
            : 'add_healthplanname'
        }`;

        const axiosMethod =
          data.healthPlanMasterId > 0 ? axios.put : axios.post;

        const response = await axiosMethod(url, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        dispatch(fetchHealthPlanMasterList());
        dispatch(fetchHealthPlanMappingList());
        props.onClose();

        if (response.data.success) {
          showToast(
            'Success',
            data.healthPlanName + ' ' + response.data.message,
            'success'
          );
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={false}
          size={'3xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold">
                <u>Health Plan Details</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody>
                <FormControl mt={2} isRequired isInvalid={isHealthPlanNameReq}>
                  <HStack>
                    <FormLabel width="40%" ml="10px" fontWeight="bold">
                      Health Plan Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      id="healthPlanName"
                      placeholder="Health Plan Name"
                      defaultValue={data.healthPlanName}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />
                
                <FormControl mt={2} isRequired isInvalid={isHealthPlanIdReq}>
                  <HStack>
                    <FormLabel width="40%" ml="10px" fontWeight="bold">
                      Health Plan Id:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      id="healthPlanId"
                      placeholder="Health Plan Id"
                      defaultValue={data.healthPlanId}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel width="40%" ml="10px" fontWeight="bold">
                      Active:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="isActive"
                      id="isActive"
                      defaultValue={
                        data.isActive == true
                          ? 'true'
                          : data.isActive == false
                          ? 'false'
                          : ''
                      }
                      onChange={e => handleChange(e)}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                  //onClick={(e) => handleSubmit(e)}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default HealthPlanMasterModalPoupup;
